import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

let Tid;
let Tbrowser;

const fetchSuiteBrowser = async () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateTestSuiteBrowser&companyid=${user.companyid}&tsuid=${Tid}&browser=${Tbrowser}`,
  );

  return response.data;
};

const useUpdateSuiteBrowser = () => {
  const query = useQuery({
    queryKey: ["updateSuiteBrowser"],
    queryFn: ({ queryKey }) => {
      const [id, browser] = queryKey;
      return fetchSuiteBrowser(id, browser);
    },
    enabled: false,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });

  const refetchWithParams = (id, browser) => {
    Tbrowser = browser;
    Tid = id;
    query.refetch();
  };

  return {
    ...query,
    refetchWithParams,
  };
};

export default useUpdateSuiteBrowser;
